module.exports = __webpack_public_path__ + "static/fonts/OpenSans600italic.58f41c44.ttf";